module.exports = __webpack_public_path__ + "static/media/alby-illustration.40ab0146.png";